import style from './style.scss';

/**
 * The FootNote component displays a footnote. Content is provided
 * as child elements.
 */
const FootNote = props => (
	<div class={style.footnote}>
		{ props.children }
	</div>
);

export default FootNote;



// WEBPACK FOOTER //
// ./components/footnote/index.js